import { Link, NavLink } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { clearKeyCache } from "../utils";
import { useContext } from "react";
import { EncryptionContext } from "./EncryptionContext";

function Navbar() {
  const [user] = useAuthState(auth);
  const { setPassphrase } = useContext(EncryptionContext);

  const handleSignOut = () => {
    auth.signOut();
    localStorage.removeItem("passphrase");
    localStorage.removeItem("userUid");
    setPassphrase("");
    clearKeyCache();
  };

  return (
    <nav className="bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark shadow-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold">
          66 Days Journal
        </Link>
        <div className="hidden md:flex gap-4 items-center">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "text-primary font-medium" : "hover:text-primary"
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/cycles"
            className={({ isActive }) =>
              isActive ? "text-primary font-medium" : "hover:text-primary"
            }
          >
            Cycles
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "text-primary font-medium" : "hover:text-primary"
            }
          >
            About
          </NavLink>
          <NavLink
            to="/blog"
            className={({ isActive }) =>
              isActive ? "text-primary font-medium" : "hover:text-primary"
            }
          >
            Blog
          </NavLink>
          {user && (
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                isActive ? "text-primary font-medium" : "hover:text-primary"
              }
            >
              Settings
            </NavLink>
          )}
          {user && (
            <NavLink
              to="/cms"
              className={({ isActive }) =>
                isActive ? "text-primary font-medium" : "hover:text-primary"
              }
            >
              CMS
            </NavLink>
          )}
          <button
            onClick={() => document.documentElement.classList.toggle('dark')}
            className="btn-secondary"
            aria-label="Toggle dark mode"
          >
            Toggle Dark Mode
          </button>
          {user ? (
            <button onClick={handleSignOut} className="btn-secondary" aria-label="Sign out">
              Sign Out
            </button>
          ) : (
            <Link to="/cycles" className="btn-primary">
              Start Journaling
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

